import React, { useState, useEffect, useContext } from "react";
import "./ContactUs.css";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import { useForm, Controller, SubmitHandler } from "react-hook-form";
import classNames from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Common_Button from "../Common-Component/Common_Button/Common_Button";
import { Link } from "react-router-dom";
import { Context } from "../../utils/context";
import { AppSetup, postContactUs } from "../../utils/apis/common/Common";

import Successfull_Modal from "../Common_modal/Successfull_Modal/Successfull_Modal";
import { faLocationDot, faPhone } from "@fortawesome/free-solid-svg-icons";
import { faClock, faEnvelope } from "@fortawesome/free-regular-svg-icons";
import Blue_Btn from "../Common-Component/common_btn/blue_btn/Blue_Btn";
import Success_Modal_2 from "../Common_modal/success_modal2/Success_Modal_2";
import { RegxExpression } from "../../utils/common";

const ContactUs = () => {
  const [showForm, setShowForm] = useState(false);
  const [showBg, setShowBg] = useState(false);
  const [successModal, setSuccessModal] = useState(false);
  const [showContactTextHolder, setShowContactTextHolder] = useState(true);

  const handleMapTextClick = () => {
    setShowForm(true);
    setShowBg(true);
    setShowContactTextHolder(false);
  };

  const handleArrowClick = () => {
    setShowContactTextHolder(true);
    setShowForm(false);
    setShowBg(false);
  };

  const { getData, IMG_URL, Select2Data } = useContext(Context);
  const {
    control,
    register,
    handleSubmit,
    getValues,
    setError,
    clearErrors,
    formState: { errors },
    reset,
    watch,
    trigger,
    setValue,
  } = useForm();

  const onSubmit = async (data) => {
    const res = await postContactUs(data);
    if (res?.success) {
      setSuccessModal(true);
      setTimeout(() => {
        setSuccessModal(false);
        reset();
      }, 3000);
    } else {
      console.error("Error fetching  data:", res?.error);
    }
  };

  const [setups, setSetup] = useState();
  const getSetup = async () => {
    const res = await AppSetup();
    if (res?.success) {
      setSetup(res?.data);
    }
  };

  useEffect(() => {
    getSetup();
  }, []);

  const data = [
    {
      label: "Call Us:",
      value: setups?.contact_no,
      icon: faPhone,
    },
    {
      label: "Email Us:",
      value: setups?.email,
      icon: faEnvelope,
    },
    {
      label: "Working Hours:",
      value: "9 AM - 7:30 PM",
      icon: faClock,
    },
    {
      label: "Location:",
      value: setups?.address,
      icon: faLocationDot,
    },
  ];

 
  

  return (
    <>
      <section className="contact_us">
        <div className="container">
          <div className="main_contact_div">
            <div className="row">
              <div className="col-lg-7">
                <div className="left_side">
                  <p className="blue_text">Send us a Message</p>
                  <p className="simple_text">
                    <b>Got questions or need support?</b> Our team is here to
                    help, every Step of the way. Reach out anytime we’ll get
                    back quickly.
                  </p>

                  <div className="form_div">
                    <Form>
                      <div className="row">
                        <div className="col-lg-12">
                          <Form.Group
                            className="mb-3 input_group"
                            controlId="exampleForm.ControlInput1"
                          >
                            <Form.Label>Name</Form.Label>
                            <Form.Control
                              type="text"
                              name="name"
                              placeholder="Enter your Name"
                              {...register("name", {
                                required: "Name is required",
                              })}
                              className={classNames("", {
                                "is-invalid": errors?.name,
                              })}
                              onKeyDown={(event) => {
                                if (!/[A-Z-a-z ]/.test(event.key)) {
                                  event.preventDefault();
                                }
                              }}
                            />
                            {errors.name && (
                              <div className="invalid-feedback">
                                {errors.name.message}
                              </div>
                            )}
                          </Form.Group>
                        </div>

                        <div className="col-lg-6">
                          <Form.Group
                            className="mb-3 input_group"
                            controlId="exampleForm.ControlInput1 "
                          >
                            <Form.Label>Email</Form.Label>
                            <Form.Control
                              type="text"
                              name="email"
                              placeholder="Enter your Email"
                              {...register("email", {
                                required: "E-mail Address is required",
                                pattern: {
                                  value:
                                    /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}(?:\.[A-Za-z]{2,})?$/,
                                  message: "Email Address Invalid",
                                },
                              })}
                              className={classNames("", {
                                "is-invalid": errors?.email,
                              })}
                            />
                            {errors.email && (
                              <div className="invalid-feedback">
                                {errors.email.message}
                              </div>
                            )}
                          </Form.Group>
                        </div>

                        <div className="col-lg-6">
                          <Form.Group
                            className="mb-3 input_group"
                            controlId="exampleForm.ControlInput1"
                          >
                            <Form.Label>Contact Number</Form.Label>
                            <Form.Control
                              type="text"
                              placeholder="Enter Mobile Number"
                              {...register("subject", {
                                required: "Mobile number is required",
                                minLength: {
                                  value: 10,
                                  message:
                                    "Mobile number must be exactly 10 digits",
                                },
                                maxLength: {
                                  value: 10,
                                  message:
                                    "Mobile number must be exactly 10 digits",
                                },
                                pattern: {
                                  value: /^[0-9]{10}$/,
                                  message: "Only numbers allowed",
                                },
                                
                              })}
                              onKeyDown={(event) => {
                                if (
                                  !/^[0-9]$/.test(event.key) &&
                                  event.key !== "Backspace"
                                ) {
                                  event.preventDefault();
                                }
                              }}
                              maxLength={10}
                              className={classNames("", {
                                "is-invalid": errors?.subject,
                              })}
                            />

                            {errors.subject && (
                              <div className="invalid-feedback">
                                {errors.subject.message}
                              </div>
                            )}
                          </Form.Group>
                        </div>

                        <div className="col-lg-12">
                          <Form.Group
                            className="mb-3 input_group"
                            controlId="exampleForm.ControlTextarea1"
                          >
                            <Form.Label>Message</Form.Label>
                            <Form.Control
                              as="textarea"
                              name="message"
                              type="text"
                              rows={3}
                              placeholder="Enter your Message"
                              {...register("message", {
                                required: "Message is required",
                              })}
                              className={classNames("", {
                                "is-invalid": errors?.message,
                              })}
                            />
                            {errors.message && (
                              <div className="invalid-feedback">
                                {errors.message.message}
                              </div>
                            )}
                          </Form.Group>
                        </div>

                        <div className="btn_holder">
                          <Blue_Btn
                            className="SubmitBtn"
                            btn_name="Send us Message"
                            padding="7px 20px"
                            onClick={handleSubmit(onSubmit)}
                          />
                        </div>
                      </div>
                    </Form>
                  </div>
                </div>
              </div>
              <div className="col-lg-5">
                <div className="blue_div">
                  <p className="white_text">
                    Hi We Are Always Here <br /> To Help You
                  </p>

                  <div className="all_info_div">
                    {data?.map((item) => {
                      return (
                        <div className="info_div">
                          <div className="icon_holder">
                            <FontAwesomeIcon
                              icon={item?.icon}
                              className="inner_icon"
                            />
                          </div>
                          <div className="text_holder">
                            <p className="label_text">{item?.label}</p>
                            <p className="value_text">{item?.value}</p>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="map-section">
          <div className="mapouter">
            <div className="gmap_canvas">
              <iframe
                className="gmap_iframe"
                frameBorder="0"
                scrolling="no"
                marginHeight="0"
                marginWidth="0"
                src={`https://maps.google.com/maps?q=${setups?.lat},${setups?.long}&hl=en&z=14&output=embed`}
              ></iframe>
              <a href="https://pdflist.com/" alt="pdflist.com"></a>
            </div>
          </div>
        </div>

        <Success_Modal_2
          show={successModal}
          onHide={() => setSuccessModal(false)}
          successText={"Inquiry Sent Successfully"}
        />

        {/* old code */}

        {/* <div className="map-section">
          <div className="mapouter">
            <div className="gmap_canvas">
              <iframe
                className="gmap_iframe"
                frameBorder="0"
                scrolling="no"
                marginHeight="0"
                marginWidth="0"
                src="https://maps.google.com/maps?q=18.049075,77.216085&hl=en&z=14&output=embed"
              ></iframe>
              <a href="https://pdflist.com/" alt="pdflist.com"></a>
            </div>
          </div>
        </div>
     
        <div
          className={`contact_form_holder ${showBg ? "contact_form_bg" : ""}`}
        >
          <div className="container">
            <div className="row justify-content-end">
              <div className="col-lg-4 col-md-4">
                <div
                  className={`contact-text-holder ${
                    showContactTextHolder ? "" : "d-none"
                  }`}
                >
                  <div className="heading-holder mb-4">
                    <h2>Contact us</h2>
                  </div>
                  <div className="d-flex mb-3">
                    <div className="icon-holder me-3">
                      <FontAwesomeIcon
                        className="call-icon"
                        icon="fa-solid fa-phone"
                      />
                    </div>
                    <div className="address-holder">
                      <p>{setups?.contact_no}</p>
                    </div>
                  </div>
                  <div className="d-flex mb-3">
                    <div className="icon-holder me-3">
                      <FontAwesomeIcon
                        className="call-icon"
                        icon="fa-solid fa-envelope"
                      />
                    </div>
                    <div className="address-holder">
                      <p>{setups?.email}</p>
                    </div>
                  </div>

                  <div className="d-flex">
                    <div className="icon-holder me-3">
                      <FontAwesomeIcon
                        className="call-icon"
                        icon="fa-solid fa-location-dot"
                      />
                    </div>
                    <div className="address-holder">
                      <p>{setups?.address}</p>
                    </div>
                  </div>

                  <div className="d-flex">
                    <div className="icon-holder me-3">
                      <FontAwesomeIcon
                        className="call-icon"
                        icon="fa-solid fa-map-location-dot"
                      />
                    </div>
                    <div
                      className="address-holder map-text"
                      onClick={handleMapTextClick}
                    >
                      <p>Find Us on Map</p>
                    </div>
                  </div>

                  <div className="border-holder  my-4"></div>
                  <div className="social-icon">
                    <Link to={"https://www.facebook.com"} target="blank">
                      {" "}
                      <img
                        src={
                          process.env.PUBLIC_URL +
                          "/assets/Image/contact/facebook.png"
                        }
                        className="facebook-icon me-2"
                      />
                    </Link>
                    <Link to={"https://in.linkedin.com/"} target="blank">
                      {" "}
                      <img
                        src={
                          process.env.PUBLIC_URL +
                          "/assets/Image/contact/linkedin.png"
                        }
                        className="facebook-icon me-2"
                      />
                    </Link>
                    <Link to={"https://in.pinterest.com/"} target="blank">
                      {" "}
                      <img
                        src={
                          process.env.PUBLIC_URL +
                          "/assets/Image/contact/pinterest.png"
                        }
                        className="facebook-icon me-2"
                      />
                    </Link>
                    <Link to={"https://x.com/"} target="blank">
                      {" "}
                      <img
                        src={
                          process.env.PUBLIC_URL +
                          "/assets/Image/contact/twitter.png"
                        }
                        className="facebook-icon"
                      />
                    </Link>
                  </div>
                </div>
              </div>
              <div
                className={`${
                  showForm
                    ? "col-xl-5 col-lg-7 col-12 scale-down-hor-right"
                    : "col-lg-8 col-md-8 scale-up-hor-right"
                }`}
              >
                <div className="form-holder ">
                  <div
                    className={`arrow-holder ${
                      showForm ? "arrow-holder" : "d-none"
                    }`}
                    onClick={handleArrowClick}
                  >
                  
                    <img
                      src={
                        process.env.PUBLIC_URL +
                        "/assets/Image/Icon/arrow-left.png"
                      }
                      className="left-arrow"
                    />
                  </div>
                  <Form>
                    <Row className="form_container">
                      <Form.Group
                        className="mb-3"
                        controlId="exampleForm.ControlInput1"
                      >
                        <Form.Control
                          type="text"
                          name="name"
                          placeholder="Name"
                          {...register("name", {
                            required: "Name is required",
                          })}
                          className={classNames("", {
                            "is-invalid": errors?.name,
                          })}
                          onKeyDown={(event) => {
                            if (!/[A-Z-a-z ]/.test(event.key)) {
                              event.preventDefault();
                            }
                          }}
                        />
                        {errors.name && (
                          <div className="invalid-feedback">
                            {errors.name.message}
                          </div>
                        )}
                      </Form.Group>
                      <Form.Group
                        className="mb-3"
                        controlId="exampleForm.ControlInput1 "
                      >
                        <Form.Control
                          type="text"
                          name="email"
                          placeholder="E-mail Address"
                          {...register("email", {
                            required: "E-mail Address is required",
                            pattern: {
                              value:
                                /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}(?:\.[A-Za-z]{2,})?$/,
                              message: "Email Address Invalid",
                            },
                          })}
                          className={classNames("", {
                            "is-invalid": errors?.email,
                          })}
                        />
                        {errors.email && (
                          <div className="invalid-feedback">
                            {errors.email.message}
                          </div>
                        )}
                      </Form.Group>
                      <Form.Group
                        className="mb-3"
                        controlId="exampleForm.ControlInput1"
                      >
                        <Form.Control
                          type="text"
                          name="subject"
                          placeholder="Subject"
                          {...register("subject", {
                            required: "Subject is required",
                          })}
                          className={classNames("", {
                            "is-invalid": errors?.subject,
                          })}
                        />
                        {errors.subject && (
                          <div className="invalid-feedback">
                            {errors.subject.message}
                          </div>
                        )}
                      </Form.Group>

                      <Form.Group
                        className="mb-3"
                        controlId="exampleForm.ControlTextarea1"
                      >
                        <Form.Control
                          as="textarea"
                          name="message"
                          type="text"
                          rows={3}
                          placeholder="Message"
                          {...register("message", {
                            required: "Message is required",
                          })}
                          className={classNames("", {
                            "is-invalid": errors?.message,
                          })}
                        />
                        {errors.message && (
                          <div className="invalid-feedback">
                            {errors.message.message}
                          </div>
                        )}
                      </Form.Group>
                      <div className="btn-holder">
                        <Common_Button
                          className="SubmitBtn"
                          text="Send Message"
                          padding="7px 20px"
                          onClick={handleSubmit(onSubmit)}
                        />
                      </div>
                    </Row>
                  </Form>
                </div>
              </div>
            </div>
          </div>
        </div> */}
      </section>

      {/* <Successfull_Modal
        show={successModal}
        onHide={() => setSuccessModal(false)}
        message={"Inquiry Sent Successfully"}
      /> */}
    </>
  );
};

export default ContactUs;
